import { TColors } from '@cian/ui-kit-design-tokens/colors';

import bonusSvg from './assets/bonus.svg';
import discountSvg from './assets/discount.svg';
import mortgageSvg from './assets/mortgage.svg';
import { ELabelType } from '../../../../types/promosPage';

export const LABEL_BACKGROUNDS: Record<ELabelType, TColors> = {
  [ELabelType.Mortgage]: 'accent-main-secondary',
  [ELabelType.NewbuildingCount]: 'background-primary',
  [ELabelType.Discount]: 'accent-positive-secondary',
  [ELabelType.Bonus]: 'accent-warning-secondary',
  [ELabelType.Installment]: 'brand-mauve',
  [ELabelType.NoOverpayments]: 'surface-positive-default',
};

export const LABEL_COLORS: Record<ELabelType, TColors> = {
  [ELabelType.Mortgage]: 'accent-main-primary',
  [ELabelType.NewbuildingCount]: 'text-primary-default',
  [ELabelType.Discount]: 'accent-positive-primary',
  [ELabelType.Bonus]: 'theme-orange',
  [ELabelType.Installment]: 'decorative-magentum',
  [ELabelType.NoOverpayments]: 'accent-positive-primary',
};

export const LABEL_ICONS_MAP: Record<ELabelType, string> = {
  [ELabelType.Bonus]: bonusSvg,
  [ELabelType.Discount]: discountSvg,
  [ELabelType.Mortgage]: mortgageSvg,
  [ELabelType.NewbuildingCount]: '',
  [ELabelType.Installment]: '',
  [ELabelType.NoOverpayments]: '',
};
